import { Form } from 'antd';
import {
  CompWithFormProp,
  FormConfigProps,
} from '../../../constants/constants';
import { subjects } from '../../../constants/subjects';
import { DynamicFormField } from '../../DynamicFormField';

export const evaluationAcusticConfig: Record<string, FormConfigProps> = {
  acousticErrors: {
    label: 'klaidomis nelaikomos akustinio pobūdžio klaidos',
    value: 'acousticErrors',
  },
};

export const lithuanianMistakes: Record<string, FormConfigProps> = {
  acousticErrors: {
    label: 'klaidomis nelaikomos akustinio pobūdžio klaidos',
    value: 'acousticErrors',
    children: {
      longAndShortVowels: {
        label: 'ilgieji ir trumpieji balsiai',
        value: 'longAndShortVowels',
        paddingLeft: 24,
        children: {
          iY: {
            label: 'i - y',
            value: 'iY',
            paddingLeft: 48,
          },
          uU: {
            label: 'u - ū',
            value: 'uU',
            paddingLeft: 48,
          },
        },
      },
      voicedAndUnvoicedConsonants: {
        label: 'skardieji ir duslieji priebalsiai',
        value: 'voicedAndUnvoicedConsonants',
        paddingLeft: 24,
        children: {
          pB: {
            label: 'p - b',
            value: 'pB',
            paddingLeft: 48,
          },
          tD: {
            label: 't - d',
            value: 'tD',
            paddingLeft: 48,
          },
          kG: {
            label: 'k - g',
            value: 'kG',
            paddingLeft: 48,
          },
          sZ: {
            label: 's - z',
            value: 'sZ',
            paddingLeft: 48,
          },
          shZh: {
            label: 'š - ž',
            value: 'shZh',
            paddingLeft: 48,
          },
        },
      },
      vowelsAndDiphthongs: {
        label: 'balsiai ir dvibalsiai',
        value: 'vowelsAndDiphthongs',
        paddingLeft: 24,
        children: {
          eE: {
            label: 'e - ė',
            value: 'eE',
            paddingLeft: 48,
          },
          eIe: {
            label: 'ė - ie',
            value: 'eIe',
            paddingLeft: 48,
          },
          eEi: {
            label: 'e - ei',
            value: 'eEi',
            paddingLeft: 48,
          },
          eEieEi: {
            label: 'e - ė - ie - ei',
            value: 'eEieEi',
            paddingLeft: 48,
          },
          oUo: {
            label: 'o - uo',
            value: 'oUo',
            paddingLeft: 48,
          },
          vowelsAndDiphthongsOther: {
            label: 'kita:',
            value: 'vowelsAndDiphthongsOther',
            isInput: true,
            paddingLeft: 48,
          },
        },
      },
      softnessMark: {
        label: 'minkštumo ženklas',
        value: 'softnessMark',
        paddingLeft: 24,
      },
      other: {
        label: 'kita:',
        value: 'other',
        isInput: true,
        paddingLeft: 24,
      },
    },
  },
};

export const EvaluationAcousticMistake = ({ form }: CompWithFormProp) => {
  const isLithuanianLanguageSelected = Form.useWatch(
    ['registration', 'selectedSubject'],
    form,
  );
  const showLithuanianAcousticMistakeOptions =
    isLithuanianLanguageSelected === subjects.LT_lang;

  return (
    <DynamicFormField
      formItemConfig={
        showLithuanianAcousticMistakeOptions
          ? lithuanianMistakes
          : evaluationAcusticConfig
      }
      formPathParams={['subject', 'block5']}
      form={form}
    />
  );
};
